import { Component, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { SelectItem } from 'primeng';
import {
  address,
  blockSpecialCharachters,
  city,
  dose_input,
  GOOGLE_RECAPTCHA_SITE_KEY,
  USER_TYPES,
  name_input,
  number_input,
  phoneNumber,
  textareaBox,
  zipCode
} from 'src/app/constant/constant';
import {
  ErrorModel,
  PromiseResult,
  ServerError
} from 'src/app/models/PromiseResult';
import { User_Registration, UserLoginOptions } from 'src/app/models/User';
import { CountriesService } from 'src/app/services/countries.service';
import { DaterenderService } from 'src/app/services/daterender.service';
import { DoctorsService } from 'src/app/services/doctors.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
@Component({
  selector: 'app-forget-email-health-care-prof',
  templateUrl: './forget-email-health-care-prof.component.html',
  styleUrls: [
    './forget-email-health-care-prof.component.css',
    './../login-home/login-home.component.css'
  ]
})
@TraceClassDecorator()
export class ForgetEmailHealthCareProfComponent implements OnInit {
  readonly name_input: RegExp = name_input;
  readonly address: RegExp = address;
  readonly city_input: RegExp = city;
  readonly phoneNumber: RegExp = phoneNumber;
  readonly zipCode: RegExp = zipCode;
  readonly textarea: RegExp = textareaBox;
  readonly dose_input: RegExp = dose_input;
  readonly number_input: RegExp = number_input;
  readonly blockSpecialCharachters: RegExp = blockSpecialCharachters;
  readonly sitekey: string = GOOGLE_RECAPTCHA_SITE_KEY;
  slug: string = '';
  readonly userTypes = USER_TYPES;

  formPosting: boolean = false;
  isPassword: boolean = true;
  recaptcha_Reset: boolean = false;
  forgotEmailDone = false;
  recaptcha: any;
  userDoctor: User_Registration = new User_Registration();
  countries: SelectItem[] = [];
  logo_url: string = '';
  response: PromiseResult;
  error: ErrorModel;
  serverError: ServerError;
  max_date = this.utilitiesService.getMaxDate();
  provider_id: string = '';
  // date_of_birth_string: string = ""

  userLoginOptions: UserLoginOptions;

  constructor(
    private readonly countriesservice: CountriesService,
    private readonly daterenderService: DaterenderService,
    public readonly doctorService: DoctorsService,
    private utilitiesService: UtilitiesService,
    private router: Router,
    private providerStateService: ProviderStateService
  ) { }

  async ngOnInit(): Promise<void> {
    this.slug = this.providerStateService.getProviderSlug();
    this.max_date = this.utilitiesService.getMaxDate();
    this.provider_id = this.providerStateService.getProviderId();
    this.userDoctor = new User_Registration();
    // this.date_of_birth_string = this.max_date;
    this.userLoginOptions = this.utilitiesService.getLoginOptionsModel(
      'PORTAL_BASE_URL',
      this.router.url,
      -1
    );
    this.max_date = this.utilitiesService.getMaxDate();
    await this.getCountries();
    this.reset_variables();
    this.ResetError();
    this.recaptchaReset();
    await this.ResetResultModels();
    this.logo_url = this.providerStateService.getLogoUrl();
  }

  async getCountries(): Promise<void> {
    await this.countriesservice
      .getCountries(this.provider_id)
      .toPromise()
      .then((countries) => {
        countries.forEach((co) => {
          this.countries.push({
            label: co.country_name,
            value: co.id
          });
        });
      });
  }

  private async ResetResultModels(): Promise<void> {
    this.response = {
      success: null,
      error: null,
      data: null
    };
    this.serverError = {
      statusCode: null,
      error: null,
      message: null
    };
  }

  recaptchaReset() {
    this.recaptcha_Reset = false;
    setTimeout(() => {
      this.recaptcha_Reset = true;
    }, 1000);
  }

  resolved(captchaResponse: any) {
    this.recaptcha = captchaResponse;
    this.userDoctor.recaptcha = this.recaptcha;
  }

  ResetError() {
    this.response = { success: true, error: null, data: null };
  }

  reset_variables(): void {
    // this.registrationDone = false;
    this.ResetError();
    // this.isPassword_Login = true;
    this.isPassword = true;
    this.forgotEmailDone = false;
    // this.forgotPasswordDone = false;
    // this.forgotDoctorPasswordDone = false;
    // this.forgotDoctorEmailDone = false;
    // this.resendDone = false;
    // this.loginDone = false;
    // this.authresult = { authtoken: "", userid: "", name: "", rememberme: false, userrole: [] }
    this.response = { success: true, error: null, data: null };
    sessionStorage.clear();
  }

  async doctorForgotEmailSubmit() {
    this.formPosting = true;
    this.recaptchaReset();
    //    await grecaptcha.reset();
    await this.doctorForgotEmail();
  }

  async doctorForgotEmail(): Promise<void> {
    this.formPosting = true;
    // this.userDoctor.date_of_birth_date = new Date(this.date_of_birth_string);
    this.userDoctor.country_id = Number(this.userDoctor.country_id);
    this.userDoctor.date_of_birth = this.daterenderService.render_data(
      this.userDoctor.date_of_birth_date
    );
    this.userDoctor.provider_id = this.provider_id;
    await this.doctorService
      .forgotEmail(this.userDoctor)
      .toPromise()
      .then((result) => {
        this.response = result;
        this.formPosting = false;
        if (this.response.success == true) {
          this.forgotEmailDone = true;
        }
      })
      .catch((error: HttpErrorResponse) => {
        this.serverError = error.error;
        this.response.success = false;
        this.formPosting = false;
      });
  }

  async openLink(
    base_url_name: string,
    link: string,
    target: string
  ): Promise<void> {
    this.utilitiesService.openWebsiteLinks(base_url_name, link, target);
  }

  getEmptyStringChecker(value: string) {
    return this.utilitiesService.getEmptyStringChecker(value);
  }
}
